import {resizeMediaByWidth} from '@wix/wixstores-client-core';
import {LineItemModel} from '../models/LineItems/LineItem.model';

type MediaDimensions = {width: number; height: number};

export const getImageDimensions = (
  lineItem: LineItemModel,
  defaultDimensions: MediaDimensions,
  successPopupUIchanges?: boolean
): MediaDimensions => {
  const primaryImage = lineItem.attributes.image;

  if (!primaryImage?.width || !primaryImage.height) {
    return defaultDimensions;
  }

  return resizeMediaByWidth(primaryImage, successPopupUIchanges ? defaultDimensions.width : 100);
};
